import { memo } from 'react';
import {
  BarChartOutlined, GlobalOutlined, MobileOutlined,
  FileTextOutlined, EnvironmentOutlined, LineChartOutlined,
} from '@ant-design/icons';
 
export type TabId = 'overview' | 'traffic' | 'devices' | 'pages' | 'cities' | 'trends' | 'reviews';

interface Tab {
  id: TabId;
  label: string;
  icon: React.ReactNode;
}

export const TABS: Tab[] = [
  { id: 'overview', label: "Vue d'ensemble",    icon: <BarChartOutlined />    },
  { id: 'traffic',  label: 'Sources de Trafic', icon: <GlobalOutlined />      },
  { id: 'devices',  label: 'Appareils',          icon: <MobileOutlined />      },
  { id: 'pages',    label: 'Pages',              icon: <FileTextOutlined />    },
  { id: 'cities',   label: 'Villes',             icon: <EnvironmentOutlined /> },
  { id: 'trends',   label: 'Tendances',          icon: <LineChartOutlined />   },
];

interface AnalyticsTabsProps {
  activeTab: TabId;
  onTabChange: (id: TabId) => void;
}

const AnalyticsTabs = memo(({ activeTab, onTabChange }: AnalyticsTabsProps) => (
  <div className="flex flex-wrap gap-1.5 mb-6 p-1.5 bg-slate-50 rounded-2xl border border-blue-50">
    {TABS.map((tab) => (
      <button
        key={tab.id}
        onClick={() => onTabChange(tab.id)}
        className={`flex items-center gap-1.5 px-3.5 py-2 rounded-xl
                    text-xs font-semibold border-none cursor-pointer
                    transition-all duration-200
                    ${
                      activeTab === tab.id
                        ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-md shadow-blue-200'
                        : 'bg-transparent text-slate-500 hover:bg-white hover:text-blue-500'
                    }`}
      >
        {tab.icon}
        <span>{tab.label}</span>
      </button>
    ))}
  </div>
));

AnalyticsTabs.displayName = 'AnalyticsTabs';

export default AnalyticsTabs;